import { useHistory } from "react-router";

import { Apps, LiveChatColored } from "@livechat/design-system-icons";
import OpenInNew from "@livechat/design-system-icons/OpenInNew";
import { Button, Icon, Modal, SpacingToken } from "@livechat/design-system-react-components";

import { IntegrationCard } from "components/integration-card/IntegrationCard";
import Flex from "components/layout/Flex";
import { trackEngagement } from "helpers/analytics";
import { withVar } from "themes/helpers";

import { SettingsRoutes } from "../constants";

import { EXTERNAL_DATA_IMPORT_URL } from "./constants";

interface IProps {
  onClose: () => void;
}

export const DataImportModal: React.FC<IProps> = ({ onClose }) => {
  const history = useHistory();

  const handleLiveChatImport = (): void => {
    trackEngagement("Settings: Data import modal: LiveChat import clicked");
    history.push(SettingsRoutes.LiveChat);
    onClose();
  };

  const handleOtherAppsImport = (): void => {
    trackEngagement("Settings: Data import modal: Other apps import clicked");
    onClose();
  };

  return (
    <Modal
      onClose={onClose}
      heading="Import data to HelpDesk"
      css={{ minWidth: "min(700px, 100%)" }}
      data-testid="data-import-modal"
    >
      <Flex paddingBottom={withVar(SpacingToken.Spacing1)} gap={withVar(SpacingToken.Spacing2)} column>
        <IntegrationCard
          icon={<Icon source={LiveChatColored} size="large" />}
          title="Import from LiveChat"
          description="Import essential data from LiveChat."
          rightNodes={
            <Button size="compact" kind="secondary" onClick={handleLiveChatImport} data-testid="livechat-import-button">
              Import
            </Button>
          }
        />
        <IntegrationCard
          icon={<Icon source={Apps} size="large" />}
          title="Import from other apps"
          description="Import data from popular industry apps."
          rightNodes={
            <Button
              size="compact"
              kind="secondary"
              icon={<Icon source={OpenInNew} size="small" />}
              iconPosition="right"
              onClick={handleOtherAppsImport}
              href={EXTERNAL_DATA_IMPORT_URL}
              target="_blank"
              data-testid="other-apps-import-button"
            >
              Import
            </Button>
          }
        />
      </Flex>
    </Modal>
  );
};
